import { render, staticRenderFns } from "./SendDocHistoryInformation.vue?vue&type=template&id=441355dc&scoped=true&"
import script from "./SendDocHistoryInformation.vue?vue&type=script&lang=js&"
export * from "./SendDocHistoryInformation.vue?vue&type=script&lang=js&"
import style0 from "./SendDocHistoryInformation.vue?vue&type=style&index=0&id=441355dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "441355dc",
  null
  
)

export default component.exports